import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { IAvailableGrant, IImpersonationGrant } from '../interfaces/impersonation-grant.interface';

export const ImpersonationGrantService = {
    createGrant: async (durationHours: number): Promise<IImpersonationGrant> => {
        const response = await axios.post(ENDPOINTS.IMPERSONATION_GRANT.BASE, { durationHours });
        return response.data;
    },

    revokeMyGrant: async (): Promise<void> => {
        await axios.delete(ENDPOINTS.IMPERSONATION_GRANT.MY);
    },

    getMyGrant: async (): Promise<IImpersonationGrant | null> => {
        const response = await axios.get(ENDPOINTS.IMPERSONATION_GRANT.MY);
        return response.data ?? null;
    },

    getAvailableGrants: async (): Promise<IAvailableGrant[]> => {
        const response = await axios.get(ENDPOINTS.IMPERSONATION_GRANT.AVAILABLE);
        return response.data;
    },
};
